module.exports = setupAddCodeProperties;

/**
 * Returns a function that adds properties from the blocklyBlock to the code object
 * @param {{[key: string]: any}} code object that contains properties for code
 * @param {import('blockly').Block} blocklyBlock object that contains parameters from blocklyBlock
 */
function setupAddCodeProperties(code, blocklyBlock) {
    if (!code) {
        throw new Error('Must pass in a code object');
    }

    if (!blocklyBlock) {
        throw new Error('Must pass in a blocklyBlock object');
    }

    /**
     * @typedef {Object} FieldValueWithHandler
     * @property {string} FieldValueWithHandler.key
     * @property {string} [FieldValueWithHandler.value]
     * @property {(value: string) => any} FieldValueWithHandler.handler
     *
     * @typedef {Object} FieldValueWithValue
     * @property {string} FieldValueWithValue.key
     * @property {string} FieldValueWithValue.value
     * @property {(value: string) => any} [FieldValueWithValue.handler]
     */

    /**
     * @param {Array<string | FieldValueWithHandler | FieldValueWithValue>} fieldValues
     */
    const addCodeProperties = fieldValues => {
        fieldValues.forEach(fieldValue => {
            if (typeof fieldValue === 'string') {
                if (blocklyBlock.getFieldValue(fieldValue) != null) {
                    code[fieldValue] = blocklyBlock.getFieldValue(fieldValue);
                }
                return;
            }

            if (!fieldValue.value) fieldValue.value = fieldValue.key;

            // if fieldValue has a handler function property, then we should run the value though it
            if (fieldValue.handler) {
                code[fieldValue.key] = fieldValue.handler(blocklyBlock.getFieldValue(fieldValue.value));
                return;
            }

            // This case can be used when the code property name and blockly fieldValue name aren't the same
            code[fieldValue.key] = blocklyBlock.getFieldValue(fieldValue.value);
        });
    };

    return addCodeProperties;
}
